import React from 'react';
import { Route } from 'works/legacy/lib/route';
import { useNavigate } from '@common/hooks';
import { RouteComponentProps } from '@common/components';

import Auth from 'works/legacy/lib/auth';
import {
  setActiveMenu,
  setActiveSecondaryMenu,
} from 'works/legacy/lib/client-store';
import { NoMatch } from '@routes/no-match';

type InternalRouteProps = Omit<
  React.ComponentProps<typeof Route>,
  'component'
> & {
  component: (
    props: RouteComponentProps<Record<string, string | undefined>>
  ) => React.ReactNode;
};

export const PrivateRoute = ({
  component: Component,
  onRender = () => {},
  menuItem,
  secondaryMenuItem = null,
  permitted = true,
  ...rest
}: InternalRouteProps & {
  onRender?: () => void;
  menuItem?: string | null;
  secondaryMenuItem?: string | null;
  permitted?: boolean;
}) => {
  const navigate = useNavigate();

  setActiveMenu(menuItem);
  setActiveSecondaryMenu(secondaryMenuItem);

  if (!Auth.signedIn()) {
    // Requires a hard refresh so that a new and valid csrf token is fetch
    // from the rails headers.
    navigate('/works/sign_in');

    return null;
  }

  if (!permitted) {
    return <NoMatch />;
  }

  onRender();

  return (
    <Route {...rest} render={(matchProps) => <Component {...matchProps} />} />
  );
};
